import styled from "styled-components";
import Src from "./visa-logo_48x15.svg";

export default styled(function VisaLogo({ className }) {
  return (
    <img src={Src} width="48" height="15" alt="Visa" className={className} />
  );
})``;
